import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import {Link} from "react-router-dom";

interface EmailConfirmedPageProps {
}

@observer export class EmailConfirmedPage extends Component<EmailConfirmedPageProps, any> {

    render() {
        return <div className={'static-page thank-you-page'}>
            <h3 className={'mt-3'}>DU HAST DEINE E-MAIL ADRESSE ERFOLGREICH REGISTRIERT</h3>

            <p>
                Du kannst ab sofort alle Funktionen von Intelingu ausprobieren und dir selbst einen Eindruck davon machen, wie sich Sprachen-Lernen auf Autopilot anfühlt.
            </p>

            <div>
                <Link to={'/course'} className={'btn btn-primary'}>LOSLEGEN</Link>
            </div>
        </div>
    }

}
